import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule }           from '../shared/shared.module';
import { TranslateConfigService } from './translate-config.service';

@NgModule({
  imports: [
    SharedModule
  ],
  providers: [
    TranslateConfigService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class InternationalizationModule {
  constructor (
    private translateConfigService: TranslateConfigService
  ) {
    this.translateConfigService.init();
  }
}
